<!-- Draws a heap with values from 0 to 9 -->
<script>
export let n = 5;
export let size = 3;
export let base_color_face="white";
export let base_color_dot="black";
export let bg_opacity=.9;
export let width = 160;
export let height = 160;
let radius = 18;

/**
 * Returns an array with `max` integers between 0 and 8
 * @param {integer} max the number of items that will have the array
 */
function generateDots(max) {
	const columns = Array(size).fill(0);

	for (let i = 0; i < max; i++) {
		const allowedColumns = columns.reduce((array, n, index) => n < size ? [...array, index] : array, []);
		const randomIndex = parseInt(Math.random() * allowedColumns.length);
		columns[allowedColumns[randomIndex]]++;
	}



	console.log('MATRIX', columns);
	const dots = [];
	const matrixPosition = (c, r) => c + r*size;

	for (let c = 0; c < size; c++) {
			for (let r = 0; r < columns[c]; r++) {
				dots.push(matrixPosition(c, size - r - 1));
			}
	}



	return dots;
}

</script>
<svg width={width} height={height} viewBox="0 0 150 150">
  <rect x={5/size * 3} y={5/size * 3} rx="20" ry="20" width="140" height="140" fill={base_color_face} fill-opacity={bg_opacity}/>
	{#each generateDots(n) as dot}
		<circle cx={32/size * 3 + 43/size * 3 *(dot%size)} cy={32/size * 3 + 43/size * 3*parseInt(dot/size)} r={radius/size * 3} fill={base_color_dot} />
	{/each}
</svg>
<style>
	rect{
 stroke:black;
stroke-width:5;
		opacity:.9;
	}
	circle{
stroke:black;
stroke-width:0;
		opacity:1;
	}
</style>